// extracted by css-extract-rspack-plugin
export default {"loadingMessage":"LoadingMessage-module__loadingMessage__tQM1w"};